// extracted by mini-css-extract-plugin
export var borderRadius = "_4p-4";
export var large = "_4p-3";
export var logoContainer = "_4p-0";
export var nameLogo = "_4p-2";
export var small = "_4p-1";